import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Button from "../../../../../ui/Button/Button";
import Label from "../../../../../ui/Label/Label";
import styles from "./PatternArticleTitle.module.scss";
import Select from "../../../../../ui/Select/Select";

const schema = z.object({
  titleType: z.enum(["keyword", "generate"]),
});

export type PatternArticleTitleData = z.infer<typeof schema>;

function PatternArticleTitle({
  onSubmit,
  defaultValue,
}: {
  onSubmit: (data: PatternArticleTitleData) => void;
  defaultValue?: PatternArticleTitleData;
}) {
  const { handleSubmit, control } = useForm<PatternArticleTitleData>({
    resolver: zodResolver(schema),
    defaultValues: defaultValue,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Label label="Article Title Type">
        <Controller
          control={control}
          name="titleType"
          render={({ field }) => (
            <Select
              data={[
                { value: "keyword", label: "Use Keyword as Title" },
                { value: "generate", label: "Generate Title" },
              ]}
              onBlur={field.onBlur}
              onChange={field.onChange}
              ref={field.ref}
              value={field.value}
            />
          )}
        />
      </Label>
      <Button className={styles.submitButton} type="submit" variant="primary">
        Continue
      </Button>
    </form>
  );
}

export default PatternArticleTitle;
